import { useQuery } from "@tanstack/react-query";

import {
  ListIntegrationEndpointsQueryFilters,
  UseListIntegrationEndpointsQueryOptions,
} from "./types";
import { getIntegrationEndpointsService } from "./service";

export const listIntegrationEndpointsQueryKey = ["v1/integration_endpoint_admin"];

export function useListIntegrationEndpointsQuery(
  filters: ListIntegrationEndpointsQueryFilters,
  options?: UseListIntegrationEndpointsQueryOptions
) {
  const queryKey = listIntegrationEndpointsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getIntegrationEndpointsService(filters),
    ...options,
  });
}
